import { useMutation } from "react-query";
import { queryClient } from "../../../../utils/query-client";
import { useAnomaliesService } from "../../../../services/anomalieService";
import { sectionsQueries } from "../../../../services/sectionService";

export function useDeleteAnomalieModalHook({onClose, selectedAnomalie}){
    const anomalyService = useAnomaliesService();
    const { mutate, isLoading } = useMutation((payload) => anomalyService.deleteAnomalies({id: selectedAnomalie.id, onSuccess}));


    function onSuccess() {
        queryClient.refetchQueries(sectionsQueries.GET_BY_ID);
        onClose();
    }


    function onSubmit() {
        mutate();
    }

    return{
        form: {
            onSubmit,
            isLoading
        }
    }
}